export const SEVERITY_STATUS = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
};

export const VERSION_STATUS = {
  UPDATE_VERSION: "UPDATE_VERSION",
  CLEAR_STATE: "CLEAR_STATE",
};

export const MAIN_PAGE_STATUS = {
  INITIAL: "INITIAL",
  CLEAR_CACHE: "CLEAR_CACHE",
  LOAD_IP_ADD: "LOAD_IP_ADD",
  LOAD_LANGUAGE: "LOAD_LANGUAGE",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  ADDED: "ADDED",
  DELETED: "DELETED",
  UPDATED: "UPDATED",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  UNAUNTHETICATED: "UNAUNTHETICATED",
  DONE: "DONE",
};

export const COMMON_STATUS = {
  INITIAL: "INITIAL",
  START: "START",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  ADDED: "ADDED",
  DELETED: "DELETED",
  UPDATED: "UPDATED",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  UNAUNTHETICATED: "UNAUNTHETICATED",
  ERROR: "ERROR",
  AUNTHETICATED: "AUNTHETICATED",
  DONE: "DONE",
};

export const INVITATION_STATUS = {
  FAILEDINVITATION: "FAILEDINVITATION",
};

export const PAGE_CART_DEFAULT_STATUS = {
  START: "START",
  INITIAL: "INITIAL",
  GET_ADDRESSES: "GET_ADDRESSES",
  ADDRESS_COUNT: "ADDRESS_COUNT",
  INITIAL_AVAIL_ADDRESS: "INITIAL_AVAIL_ADDRESS",
  INITIAL_AVAIL_DATE: "INITIAL_AVAIL_DATE",
  INITIAL_DEFAULT: "INITIAL_DEFAULT",

  LOAD_ADDRESS: "LOAD_ADDRESS",

  INITIAL_LOAD_CARTS: "INITIAL_LOAD_CARTS",
  INITIAL_LOAD_DISABLED_DAYS: "INITIAL_LOAD_DISABLED_DAYS",
  INITIAL_LOAD_SAVEDDAYS: "INITIAL_LOAD_SAVEDDAYS",
  DONE: "DONE",
  FAILED: "FAILED",
  NOADDRESSES: "NOADDRESSES",

  GET_STANDING_ORDER_DETAILS: "GET_STANDING_ORDER_DETAILS",
  CHECK_STANDING_ORDER_DETAILS: "CHECK_STANDING_ORDER_DETAILS",
  GROUPING_STANDING_ORDER_DETAILS: "GROUPING_STANDING_ORDER_DETAILS",
  FILTER_STANDING_ORDER_DETAILS: "FILTER_STANDING_ORDER_DETAILS",
};

export const CART_DEFAULT_STATUS = {
  INITIAL_DEFAULT: "INITIAL_DEFAULT",
  LOADING_DEFAULT: "LOADING_DEFAULT",
  LOADED_DEFAULT: "LOADED_DEFAULT",
  FAILED_DEFAULT: "FAILED_DEFAULT",
  INITIAL_AVAIL_DATE: "INITIAL_AVAIL_DATE",
  LOADING_AVAIL_DATE: "LOADING_AVAIL_DATE",
  LOADED_AVAIL_DATE: "LOADED_AVAIL_DATE",
  FAILED_AVAIL_DATE: "FAILED_AVAIL_DATE",
  INITIAL_CARTS: "INITIAL_CARTS",
  LOADED_CARTS: "LOADED_CARTS",
  FAILED_CARTS: "FAILED_CARTS",
  LOADED_SAVEDCARTS: "LOADED_SAVEDCARTS",
  FAILED_SAVEDCARTS: "FAILED_SAVEDCARTS",
};

export const CART_STATUS = {
  START: "START",
  INITIAL_CART: "INITIAL_CART",
  LOADING_GET_CART: "LOADING_GET_CART",
  LOADED_GET_CART: "LOADED_GET_CART",
  FAILED_GET_CART: "FAILED_GET_CART",
  CREATE_CART: "CREATE_CART",
  CREATED_CART: "CREATED_CART",
  ADD_POSITION_CART: "ADD_POSITION_CART",
  DELETE_POSITION_CART: "DELETE_POSITION_CART",
  UPDATE_POSITION_CART: "UPDATE_POSITION_CART",
  UPDATE_CART: "UPDATE_CART",
  SEND_PLACE_CART: "SEND_PLACE_CART",
  DONE_PLACE_CART: "DONE_PLACE_CART",
  FAILED_PLACE_CART: "FAILED_PLACE_CART",
  SEND_DELETE_CART: "SEND_DELETE_CART",
  DONE_DELETE_CART: "DONE_DELETE_CART",
  FAILED_DELETE_CART: "FAILED_DELETE_CART",
  SEND_CANCELSO_CART: "SEND_CANCELSO_CART",
  DONE_CANCELSO_CART: "DONE_CANCELSO_CART",
  FAILEDCANCELSO_CART: "FAILEDCANCELSO_CART",
  START_VALIDATEDATE_CART:"START_VALIDATEDATE_CART",
  LOADING_VALIDATEDATE_CART:"LOADING_VALIDATEDATE_CART",
  DONE_VALIDATEDATE_CART:"DONE_VALIDATEDATE_CART",
  FAILED_VALIDATEDATE_CART:"FAILED_VALIDATEDATE_CART",
};

export const CART_FROM = {
  INITIAL: "INITIAL",
  CART_DEFAULT: "CART_DEFAULT",
  ITEM_ADDED: "ITEM_ADDED",
  CART_RELOAD: "CART_RELOAD",
  CART_DONE: "CART_DONE",
  ITEM_DELETE: "ITEM_DELETED",
};

export const CART_PAGE_STATUS = {
  INITIAL: "INITIAL",
  LOADED_LOCAL_STORE: "LOADED_LOCAL_STORE",
  LOADED_LOCAL_POSITIONS: "LOADED_LOCAL_POSITIONS",
  DONE: "DONE",
};

export const CART_CHANGE_TYPE = {
  ADDRESS: 1,
  DATE: 2,
};

export const APP_LOADING_STATUS = {
  INITIAL: "INITIAL",
  STORAGE_DONE: "STORAGE_DONE",
  VERSION_DONE: "VERSION_DONE",
  CLIENT_DONE: "CLIENT_DONE",
  TENANT_INFO_DONE: "TENANT_INFO_DONE",
  TENANT_INFO_FAILED: "TENANT_INFO_FAILED",
  TRADERS_START: "TRADERS_START",
  TRADERS_DONE: "TRADERS_DONE",
  LOADED_ALL_DATA: "LOADED_ALL_DATA",
};

export const CART_PAGE_FLOW = {
  START: "START",
  INITIAL: "INITIAL",
  LOADED_PERMISSION: "LOADED_PERMISSION",
  DONE: "DONE",
};

export const PAGE_FLOW = {
  START: "START",
  INITIAL: "INITIAL",
  LOADED_PERMISSION: "LOADED_PERMISSION",
  DONE: "DONE",
  COMPLETE: "COMPLETE",
};

export const OVERALL_PAGE_FLOW = {
  START: "START",
  LOGIN: "LOGIN",
  INVITATION: "INVITATION",
  LOGGED: "LOGGED",
};
